import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';
import "./BreadCrumbComponent.css";
import { withAITracking } from '@microsoft/applicationinsights-react-js';
import { reactPlugin, appInsights } from '../../AppInsights';
import { Menubar } from 'primereact/menubar';
import { Badge } from 'primereact/badge';
import { IssuesDetailsService } from '../Issues/IssuesDetailsService';
import { AdminService } from '../admin/AdminService';
import { icon } from '@fortawesome/fontawesome-svg-core';
import MENU_CONFIG from '../bread-crumb/MenuConfig';

class BreadCrumbComponent extends Component {
    constructor(props) {
        super(props);
        this._isIssueDetailsMounted = false;
        this.state = {
            IssueDashboardCount: {},
            pageErrorMessage: null
        }
        this.issuesDetailsService = new IssuesDetailsService();
        this.adminService = new AdminService();
    }

    componentDidMount() {
        this._isIssueDetailsMounted = true;
        this.getIssueCount();
        this.getAdminRoles();
    }

    getAdminRoles = () => {
        this.adminService.getAdminRoles(this.props.msalContext).then(
            (d) => {
                this.setState({ adminRoles: d, pageErrorMessage: null });
                this.initializeMenuItems();
            }
        ).catch(e => {
            console.log(e)
        });
    }

    getRoleId = () => {
        var adminRoles = this.state.adminRoles;
        if (adminRoles && adminRoles.length > 0) {
            switch (true) {
                case adminRoles.includes('SuperAdmin'):
                case adminRoles.includes('Admin'):
                case adminRoles.includes('Developer'):
                    return 1;
                default:
                    return 0;
            }
        }
        return 0;
    }

    initializeMenuItems = () => {
        const roleId = this.getRoleId();
        this.items = this.buildMenuItems(roleId);
    }

    buildMenuItems = (roleId) => {
        const menuItems = [];

        // Add common items  
        menuItems.push(...this.convertToMenuFormat(MENU_CONFIG.commonItems));

        // Add manage incident  
        menuItems.push(this.getManageIncidentItem());

        // Add monitor  
        menuItems.push(this.convertItemToMenu(MENU_CONFIG.monitor));

        // Add other items  
        menuItems.push(...this.convertToMenuFormat(MENU_CONFIG.otherItems));

        // Add reports  
        menuItems.push(this.convertItemToMenu(MENU_CONFIG.reports));

        // Add administration  
        menuItems.push(this.getAdministrationMenu(roleId));

        return menuItems;
    }

    convertToMenuFormat = (items) => {
        return items.map(item => ({
            label: item.label,
            path: item.path,
            icon: item.icon,
        }));
    }

    convertItemToMenu = (item) => {
        return {
            label: item.label,
            icon: item.icon,
            items: this.convertToMenuFormat(item.items)
        };
    }

    getManageIncidentItem = () => ({
        template: (
            <div>
                <a href="/issues" role="menuitem" className="p-menuitem-link" aria-haspopup="false">
                    <Badge value={this.state.IssueDashboardCount.Error || 0} severity="danger"></Badge>
                    Manage Incident
                </a>
            </div>
        )
    });

    getAdministrationMenu = (roleId) => {
        let adminItems = [...MENU_CONFIG.admin.commonItems];

        if (roleId === 1) {
            adminItems.splice(2, 0, ...MENU_CONFIG.admin.adminOnlyItems);
        }

        return {
            label: 'Administration',
            icon: 'pi pi-fw pi-user-edit',
            items: this.convertToMenuFormat(adminItems)
        };
    }


    getIssueCount() {
        this.issuesDetailsService.getIssueCount(this.props.msalContext).then(
            (d) => {
                if (d.status === 403) {
                    this.setState({ pageErrorMessage: 'You do not have permission to view this page.', hideSpinner: true });
                } else {
                    if (this._isIssueDetailsMounted) {
                        this.setState({ IssueDashboardCount: d.body, pageErrorMessage: null });
                    }
                }
            }
        ).catch(e => {
            this.setState({ pageErrorMessage: 'Something went wrong !!!' })
            console.log(e)
        });
    }

    render() {
        //For Menu Bar
        this.items =
            this.getRoleId() === 1 ?
                [
                    {
                        label: 'Home', command: () => { window.location = "/incident/dashboard"; }, icon: 'pi pi-fw pi-home',
                    },
                    {
                        label: 'Platform Health', command: () => { window.location = "/leader/dashboard"; }, icon: 'pi pi-heart',
                    },
                    {
                        template: <div>
                            <a href="/issues" role="menuitem" class="p-menuitem-link" aria-haspopup="false">
                                <span class="p-menuitem-icon pi pi-fw pi-bell mr-3 p-text-secondary p-overlay-badge" style={{ fontSize: '18px' }}>
                                    <Badge value={this.state.IssueDashboardCount.Error || 0} severity="danger"></Badge>
                                </span>
                                <span class="p-menuitem-text">Manage Incident</span>
                            </a>
                        </div>
                    },
                    {
                        label: 'Monitor', icon: 'pi pi-fw pi-desktop',
                        items: [
                            {
                                label: 'Inbound Inactivity', command: () => { window.location = "/monitor/inboundmetric"; }, icon: 'pi pi-fw pi-angle-double-right'
                            },
                            {
                                label: 'Queues', command: () => { window.location = "/monitor/queues"; }, icon: 'pi pi-fw pi-arrow-right-arrow-left'
                            },
                            {
                                label: 'Scheduled Task', command: () => { window.location = "/monitor/taskschedule"; }, icon: 'pi pi-fw pi-stopwatch'
                            },
                            {
                                label: 'Database Size', command: () => { window.location = "/monitor/databasesize"; }, icon: 'pi pi-database'
                            },
                            {
                                label: 'Mirror Status', command: () => { window.location = "/monitor/mirrors"; }, icon: 'pi pi-fw pi-clone'
                            },
                            {
                                label: 'Galileo', command: () => { window.location = "/galileo"; }, icon: 'pi pi-chart-bar'
                            }
                        ]
                    },
                    {
                        label: 'Production Items', command: () => { window.location = "/monitor/production/items"; }, icon: 'pi pi-fw pi-sliders-h'
                    },
                    {
                        label: 'IACL', command: () => { window.location = "/iacl"; }, icon: 'pi pi-fw pi-bolt'
                    },
                    {
                        label: 'IP Port List', command: () => { window.location = "/production/ipport"; }, icon: 'pi pi-map-marker'
                    },
                    {
                        label: 'Reports', icon: 'pi pi-fw pi-paperclip',
                        items: [
                            {
                                label: 'Interface Count', command: () => { window.location = "/report/interfacecount"; }, icon: 'pi pi-fw pi-list'
                            },
                            {
                                label: 'Interface Tracker', command: () => { window.location = "/report/interfacetracker"; }, icon: 'pi pi-fw pi-list'
                            },
                        ]
                    },
                    {
                        label: 'Administration', icon: 'pi pi-fw pi-user-edit',
                        items: [
                            {
                                label: 'Do-not-monitor', command: () => { window.location = "/notification/blackout/rules"; }, icon: 'pi pi-eye-slash'
                            },
                            {
                                label: 'Restore Connection', command: () => { window.location = "/restore/connection"; }, icon: 'pi pi-fw pi-replay'
                            },
                            {
                                label: 'Alert Rule', icon: 'pi pi-fw pi-book',
                                items: [
                                    {
                                        label: 'Custom Alert', command: () => { window.location = "/admin/custom/hie/alert/rules"; }, icon: 'pi pi-fw pi-send'
                                    },
                                    {
                                        label: 'Azure Alert', command: () => { window.location = "/admin/custom/azure/alert/rules"; }, icon: 'pi pi-fw pi-cloud'
                                    },
                                    {
                                        label: 'Threshold Rule', command: () => { window.location = "/admin/threshold/rules"; }, icon: 'pi pi-fw pi-list'
                                    },
                                    {
                                        label: 'Alert Processing', command: () => { window.location = "/admin/alert/processing/rules"; }, icon: 'pi pi-fw pi-cog'
                                    },
                                ]
                            },
                            {
                                label: 'IACL Configs', icon: 'pi pi-fw pi-cog',
                                items: [
                                    { label: 'Applications', command: () => { window.location = "/application"; }, icon: 'pi pi-fw pi-box' },
                                    { label: 'CA Group Names', command: () => { window.location = "/cagroupname"; }, icon: 'pi pi-fw pi-users' },
                                    { label: 'Connection Types', command: () => { window.location = "/connectiontypes"; }, icon: 'pi pi-fw pi-wifi' },
                                    { label: 'Message Types', command: () => { window.location = "/messagetype"; }, icon: 'pi pi-fw pi-list' },
                                    { label: 'Message Content', command: () => { window.location = "/messagecontent"; }, icon: 'pi pi-fw pi-book' },
                                    { label: 'Site Names', command: () => { window.location = "/sitenames"; }, icon: 'pi pi-fw pi-building' },
                                ]
                            },
                            {
                                label: 'Action Group', command: () => { window.location = "/admin/alert/actiongroup"; }, icon: 'pi pi-fw pi-users'
                            },
                            {
                                label: 'Rabbit Mq Users', command: () => { window.location = "/rabbitmq/authusers"; }, icon: 'pi pi-fw pi-user'
                            }
                        ]
                    }
                ] :
                [
                    {
                        label: 'Home', command: () => { window.location = "/incident/dashboard"; }, icon: 'pi pi-fw pi-home',
                    },
                    {
                        label: 'Platform Health', command: () => { window.location = "/leader/dashboard"; }, icon: 'pi pi-heart',
                    },
                    {
                        template: <div>
                            <a href="/issues" role="menuitem" class="p-menuitem-link" aria-haspopup="false">
                                <span class="p-menuitem-icon pi pi-fw pi-bell mr-3 p-text-secondary p-overlay-badge" style={{ fontSize: '18px' }}>
                                    <Badge value={this.state.IssueDashboardCount.Error || 0} severity="danger"></Badge>
                                </span>
                                <span class="p-menuitem-text">Manage Incident</span>
                            </a>
                        </div>
                    },
                    {
                        label: 'Monitor', icon: 'pi pi-fw pi-desktop',
                        items: [
                            {
                                label: 'Inbound Inactivity', command: () => { window.location = "/monitor/inboundmetric"; }, icon: 'pi pi-fw pi-angle-double-right'
                            },
                            {
                                label: 'Queues', command: () => { window.location = "/monitor/queues"; }, icon: 'pi pi-fw pi-arrow-right-arrow-left'
                            },
                            {
                                label: 'Scheduled Task', command: () => { window.location = "/monitor/taskschedule"; }, icon: 'pi pi-fw pi-stopwatch'
                            },
                            {
                                label: 'Database Size', command: () => { window.location = "/monitor/databasesize"; }, icon: 'pi pi-database'
                            },
                            {
                                label: 'Mirror Status', command: () => { window.location = "/monitor/mirrors"; }, icon: 'pi pi-fw pi-clone'
                            },
                            {
                                label: 'Galileo', command: () => { window.location = "/galileo"; }, icon: 'pi pi-chart-bar'
                            }
                        ]
                    },
                    {
                        label: 'Production Items', command: () => { window.location = "/monitor/production/items"; }, icon: 'pi pi-fw pi-sliders-h'
                    },
                    {
                        label: 'IACL', command: () => { window.location = "/iacl"; }, icon: 'pi pi-fw pi-bolt'
                    },
                    {
                        label: 'IP Port List', command: () => { window.location = "/production/ipport"; }, icon: 'pi pi-map-marker'
                    },
                    {
                        label: 'Reports', icon: 'pi pi-fw pi-paperclip',
                        items: [
                            {
                                label: 'Interface Count', command: () => { window.location = "/report/interfacecount"; }, icon: 'pi pi-fw pi-list'
                            },
                            {
                                label: 'Interface Tracker', command: () => { window.location = "/report/interfacetracker"; }, icon: 'pi pi-fw pi-list'
                            },
                        ]
                    },
                    {
                        label: 'Administration', icon: 'pi pi-fw pi-user-edit',
                        items: [
                            {
                                label: 'Do-not-monitor', command: () => { window.location = "/notification/blackout/rules"; }, icon: 'pi pi-eye-slash'
                            },
                            {
                                label: 'Restore Connection', command: () => { window.location = "/restore/connection"; }, icon: 'pi pi-fw pi-replay'
                            },
                            {
                                label: 'IACL Configs', icon: 'pi pi-fw pi-cog',
                                items: [
                                    { label: 'Applications', command: () => { window.location = "/application"; }, icon: 'pi pi-fw pi-box' },
                                    { label: 'CA Group Names', command: () => { window.location = "/cagroupname"; }, icon: 'pi pi-fw pi-users' },
                                    { label: 'Connection Types', command: () => { window.location = "/connectiontypes"; }, icon: 'pi pi-fw pi-wifi' },
                                    { label: 'Message Types', command: () => { window.location = "/messagetype"; }, icon: 'pi pi-fw pi-list' },
                                    { label: 'Message Content', command: () => { window.location = "/messagecontent"; }, icon: 'pi pi-fw pi-book' },
                                    { label: 'Site Names', command: () => { window.location = "/sitenames"; }, icon: 'pi pi-fw pi-building' },
                                ]
                            },
                            {
                                label: 'Action Group', command: () => { window.location = "/admin/alert/actiongroup"; }, icon: 'pi pi-fw pi-users'
                            },
                            {
                                label: 'Rabbit Mq Users', command: () => { window.location = "/rabbitmq/authusers"; }, icon: 'pi pi-fw pi-user'
                            }
                        ]
                    }
                ];

        return (
            <div>
                <div className="breadCrumbContainer">
                    <div>
                        <Menubar model={this.items} />
                    </div>
                </div>
            </div>
        );
    }
};
//export default BreadCrumbComponent;
export default withAITracking(reactPlugin, BreadCrumbComponent);
